module.exports = function (app, mod, tx) {
  var _txmsg$data;
  var txmsg = tx.returnMessage();
  var txsig = '';
  var tweet_to_show = '';
  var from = tx.from[0].publicKey;
  if ((_txmsg$data = txmsg.data) !== null && _txmsg$data !== void 0 && _txmsg$data.signature) {
    txsig = txmsg.data.signature;
  }
  return "\n        <div class=\"tweet tweet-notification notification-item-".concat(from, "-").concat(txsig, " tweet-notif-fav\" data-id=\"").concat(txsig, "\" data-curated=\"1\">\n          <div class=\"tweet-notice\"></div>\n          <div class=\"tweet-header\"></div>\n          <div class=\"tweet-body\">\n            <div class=\"tweet-sidebar\"></div>\n            <div class=\"tweet-main\">\n              <div class=\"tweet-preview\"></div>\n            </div>\n          </div>\n        </div>\n    ");
};